import { IUserProfile } from './../types/userTypes';
import {userType} from '../constanst/index';

const initialState:IUserProfile={
        username:'',
		email:'',
		firstName:'',
		lastName:''
}

const userReducer = (state=initialState, action:any) =>{
   
    switch(action.type){
        case userType.FETCH_USER_PROFILE:
            return{
                username:action.payload.username,
		        email:action.payload.email,
		        firstName:action.payload.firstName,
		        lastName:action.payload.lastName
            }
        default:
            return state;
    }
}

export default userReducer;